export const nivelesSuscripcion = [
  {
    id: 0,
    nombre: "Acceso Libre",
    descripcion: "Recursos disponibles para todos los usuarios sin restricción",
    caracteristicas: [
      "Acceso inmediato",
      "Registro gratuito",
      "Contenido básico"
    ]
  },
  {
    id: 1,
    nombre: "Nivel Bronce",
    descripcion: "Acceso a recursos básicos premium",
    caracteristicas: [
      "Recursos exclusivos básicos",
      "Acceso a material didáctico especial",
      "Contenido adicional"
    ]
  },
  {
    id: 2,
    nombre: "Nivel Plata",
    descripcion: "Acceso a recursos intermedios premium",
    caracteristicas: [
      "Todo lo del nivel Bronce",
      "Recursos exclusivos intermedios",
      "Material didáctico avanzado",
      "Acceso prioritario a nuevos recursos"
    ]
  },
  {
    id: 3,
    nombre: "Nivel Oro",
    descripcion: "Acceso completo a todos los recursos premium",
    caracteristicas: [
      "Todo lo de los niveles anteriores",
      "Recursos exclusivos premium",
      "Material didáctico especializado",
      "Acceso anticipado a nuevos recursos",
      "Soporte prioritario"
    ]
  },
  {
    id: 9,
    nombre: "Administrador",
    descripcion: "Acceso total a la plataforma, gestión de usuarios y recursos.",
    caracteristicas: [
      "Acceso a todos los recursos y niveles",
      "Gestión de usuarios",
      "Gestión de materiales y recursos",
      "Soporte y administración avanzada"
    ]
  }
]; 